export default {
    baseUrl: 'https://api.air-vote.com',
    isDev: false,
    siteUrl: 'https://air-vote.com',
    url: 'https://my.air-vote.com/'
}
